import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DataCardService {

  private rowIndex = new Subject<any>();
  
  onIndexChange = this.rowIndex.asObservable();

  notifyAll(index):void  {
    this.rowIndex.next(index);
  }
}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card.service.ts